import {Button, localStorageStore, TopToolbar, useRecordContext} from "react-admin";
import * as React from "react";
import { GetApp } from "@mui/icons-material";
import { useKeycloak } from '@react-keycloak/web'

const ShowActionsAbholgebietTermineExport = (props) => {
    const {keycloak, initialized} = useKeycloak()
    const record = useRecordContext();
    const store = localStorageStore();
    const apiUrl = store.getItem('apiUrl');

    return (
        <TopToolbar {...props}>
            <Button
                onClick={() => {
                    fetch(
                        apiUrl + '/abholgebiet-termine-export' +
                        '?abholgebiet=' + record.id +
                        '&zeitraum=2021-09-01',
                        {
                            headers: {
                                'Accept': 'application/json',
                                'Authorization': 'Bearer ' + keycloak.token
                            }
                        }
                    )
                        .then(response => response.json())
                        .then(json => {
                            window.location = json.url;
                        })
                }}
                label="Export Abholtermine (.ics)"
            >
                <GetApp/>
            </Button>
        </TopToolbar>
    )
}

export default ShowActionsAbholgebietTermineExport;